import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';
import CompanyLink from 'components/models/company/company-link';


function CompanyNickname({ company, companies, className, noLink }) {
  if (!company || (_.isObject(company) && _.isEmpty(company))) return null;
  
  const fullCompany = _.isNumber(company) ? (_.find(companies, { id: company }) || {}) : company;

  if (noLink) return <InnerNickname company={fullCompany} className={className} />;

  return (
    <CompanyLink company={fullCompany} className={className}>
      <InnerNickname company={fullCompany} />
    </CompanyLink>
  );
}

CompanyNickname.propTypes = {
  company: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number
  ]),
  companies: PropTypes.array,
  className: PropTypes.string,
  noLink: PropTypes.bool
};

export default connect((state) => ({
  companies: state.pageData.selectCompanies
}))(CompanyNickname);


// Inner Component
function InnerNickname({ company, className }) { // eslint-disable-line react/prop-types
  return (
    <Tooltip className={classNames('company-nickname', className)} title={company.name} elementType="span">
      {company.nickname}
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./app/components/models/company/company-nickname.js